var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("翻新设备")]),_c('el-breadcrumb-item',[_vm._v("设备回收请求")])],1),_c('device-quest-list',{attrs:{"category":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }